import i18n, { use } from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import Backend from 'i18next-http-backend';
import moment from 'moment';
import { initReactI18next } from 'react-i18next';

import translationEN from '../../assets/translation/en/translation.json';
import translationES from '../../assets/translation/es/translation.json';
import translationPT from '../../assets/translation/pt/translation.json';
import { BUCKET_URL_BASE_DEV, BUCKET_URL_BASE_PROD, IS_DEV, USE_MOCKS } from '../constants/constants';
import {
  DEFAULT_LANGUAGE_MOCK,
  FALLBACK_LANGUAGE,
  FALLBACK_LANGUAGE_MOCK,
  SUPPORTED_ISO_CODES
} from '../constants/i18n';

const localResources = {
  es: { translation: translationES },
  en: { translation: translationEN },
  pt: { translation: translationPT }
};

!USE_MOCKS
  ? use(Backend)
      .use(LanguageDetector)
      .use(initReactI18next)
      .init({
        fallbackLng: FALLBACK_LANGUAGE,
        supportedLngs: SUPPORTED_ISO_CODES,
        nonExplicitSupportedLngs: true,
        backend: {
          loadPath: (lng, ns) => {
            return IS_DEV
              ? `${BUCKET_URL_BASE_DEV}/locales/${lng}/${ns}.json`
              : `${BUCKET_URL_BASE_PROD}/locales/${lng}/${ns}.json`;
          }
        },
        debug: false,
        compatibilityJSON: 'v3',
        detection: {
          excludeCacheFor: ['cimode', ...SUPPORTED_ISO_CODES]
        }
      })
      .then(() => {
        Object.entries(localResources).forEach(([lng, namespaces]) => {
          Object.entries(namespaces).forEach(([ns, resources]) => {
            i18n.addResourceBundle(lng, ns, resources, true, false);
          });
        });
        moment.locale(i18n.resolvedLanguage);
      })
  : use(
      initReactI18next || {
        type: '3rdParty' as const,
        init: () => {
          void 0;
        }
      }
    ) // eslint-disable-line @typescript-eslint/no-empty-function
      .init({
        lng: DEFAULT_LANGUAGE_MOCK,
        fallbackLng: FALLBACK_LANGUAGE_MOCK,
        supportedLngs: SUPPORTED_ISO_CODES,
        resources: localResources,
        debug: false,
        compatibilityJSON: 'v3',
        detection: {
          excludeCacheFor: ['cimode', ...SUPPORTED_ISO_CODES]
        }
      })
      .then(() => moment.locale(i18n.resolvedLanguage));

export default i18n;
